import { Link } from "gatsby";
import PropTypes from "prop-types";
import React from "react";

import "./header.css";

const activeStyles = {
  color: "white"
};

const Header = () => (
  <nav className="navbar navbar-expand-xl navbar-dark">
    <button
      className="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#szelenceMenuNavbar"
      aria-controls="szelenceMenuNavbar"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span className="navbar-toggler-icon"></span>
    </button>

    <div
      className="collapse navbar-collapse justify-content-md-center"
      id="szelenceMenuNavbar"
    >
      <ul className="navbar-nav">
        <li className="nav-item p-3">
          <Link
            to="/unnepi-ajanlat"
            className="menu-point christmas"
            activeStyle={activeStyles}
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Ünnepi ajánlat
          </Link>
        </li>
        <li className="nav-item p-3">
          <Link to="/" className="menu-point" activeClassName="active">
            Főoldal
          </Link>
        </li>
        <li className="nav-item p-3">
          <Link
            to="/rolunk"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Rólunk
          </Link>
        </li>
        <li className="nav-item p-3">
          <Link
            to="/eteleink"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Ételeink
          </Link>
        </li>
        <li className="nav-item p-3">
          <Link
            to="/tortarendeles"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Tortarendelés
          </Link>
        </li>

        <li className="nav-item p-3">
          <Link
            to="/teremberles"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Terembérlés
          </Link>
        </li>
        {/* <li className="nav-item p-3">
          <Link
            to="/eskuvo"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Esküvő
          </Link>
        </li> */}
        <li className="nav-item p-3">
          <Link
            to="/kapcsolat"
            className="menu-point"
            activeClassName="active"
            getProps={({ isPartiallyCurrent }) =>
              isPartiallyCurrent ? { style: { ...activeStyles } } : null
            }
          >
            Kapcsolat
          </Link>
        </li>
      </ul>
    </div>
  </nav>
);

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default Header;
